/* eslint-disable no-unused-vars */
import {
  Box,
  FormControl,
  FormLabel,
  Input,
  SimpleGrid,
  Text,
} from "@chakra-ui/react";
import InputMask from "react-input-mask";
import Select from "react-select";
import { useDropdownOptions } from "../../../../hooks/useDropdownOptions";
import { useGetCodes } from "../../../../hooks/useGetCodes";
import { selectStyles } from "../../../../utils/selectStyel";
const BasicInformationFormSection = ({ register, setValue, watch }) => {
  const { data, isLoading } = useGetCodes("LINK_TYPES");
  const { options: raceOptions, isLoading: isRaceLoading } =
    useDropdownOptions("RACE");
  const {
    options: tribeOptions,
    isLoading: isJURISDICTIONAL_ASSIGNMENTLoading,
  } = useDropdownOptions("JURISDICTIONAL_ASSIGNMENT");
  const { options: caseTypeOptions, isLoading: iscaseTypeOptionsRaceLoading } =
    useDropdownOptions("CASE_TYPE");
  const { options: genderOptions, isLoading: isgenderOptionsLoading } =
    useDropdownOptions("GENDER");
  // const linkTypeSelectOptions =
  //   demoLinkTypeResponse?.CONFIG?.map((opt) => ({
  //     value: opt.CODE,
  //     label: opt.TEXT,
  //   })) || [];
  const linkTypeSelectOptions =
    data?.CONFIG?.map((opt) => ({
      value: opt.CODE,
      label: opt.TEXT,
    })) || [];

  return (
    <Box w="30%">
      <Text fontSize="sm" fontWeight="bold" mb={1}>
        Basic Information
      </Text>
      <SimpleGrid columns={{ base: 1, md: 2 }} spacing={2}>
        <FormControl>
          <FormLabel size="sm" mb={0} color="gray.600" fontWeight="normal">
            First Name
          </FormLabel>
          <Input size="sm" borderRadius="md" {...register("FIRST_NAME")} />
        </FormControl>

        <FormControl>
          <FormLabel size="sm" mb={0} color="gray.600" fontWeight="normal">
            Last Name
          </FormLabel>
          <Input size="sm" borderRadius="md" {...register("LAST_NAME")} />
        </FormControl>

        <FormControl>
          <FormLabel size="sm" mb={0} color="gray.600" fontWeight="normal">
            Middle Name
          </FormLabel>
          <Input size="sm" borderRadius="md" {...register("MIDDLE_NAME")} />
        </FormControl>

        <FormControl>
          <FormLabel size="sm" mb={0} color="gray.600" fontWeight="normal">
            Alias
          </FormLabel>
          <Input size="sm" borderRadius="md" {...register("ALIAS")} />
        </FormControl>
        <FormControl>
          <FormLabel size="sm" mb={1} color="gray.600" fontWeight="normal">
            Tribe
          </FormLabel>
          <Select
            key={tribeOptions.length}
            options={tribeOptions}
            isMulti
            onChange={(selected) =>
              setValue(
                "TRIBE",
                selected ? selected.map((opt) => opt.value) : []
              )
            }
            value={tribeOptions.filter((opt) =>
              watch("TRIBE")?.includes(opt.value)
            )}
          />
        </FormControl>

        <FormControl>
          <FormLabel size="sm" mb={1} color="gray.600" fontWeight="normal">
            Race
          </FormLabel>
          <Select
            options={raceOptions}
            isMulti
            onChange={(selected) =>
              setValue("RACE", selected ? selected.map((opt) => opt.value) : [])
            }
            value={raceOptions.filter((opt) =>
              watch("RACE")?.includes(opt.value)
            )}
          />
        </FormControl>
        <FormControl>
          <FormLabel size="sm" color="gray.600" fontWeight="normal">
            Links Type
          </FormLabel>
          <Select
            options={linkTypeSelectOptions}
            isLoading={isLoading}
            onChange={(selected) =>
              setValue("LINK_TYPE", selected?.value || "")
            }
            value={
              linkTypeSelectOptions.find(
                (opt) => opt.value === watch("LINK_TYPE")
              ) || null
            }
            isClearable
          />
        </FormControl>

        <FormControl>
          <FormLabel size="sm" mb={1} color="gray.600" fontWeight="normal">
            Gender
          </FormLabel>
          <Select
            options={genderOptions}
            onChange={(selected) => setValue("GENDER", selected?.value || "")}
            value={
              genderOptions.find((opt) => opt.value === watch("GENDER")) || null
            }
            isClearable
          />
        </FormControl>
        <FormControl>
          <FormLabel size="sm" mb={0} color="gray.600" fontWeight="normal">
            Birth Date
          </FormLabel>
          <Input
            type="date"
            size="sm"
            borderRadius="md"
            onChange={(e) => {
              const rawValue = e.target.value;
              const formatted = rawValue.replace(/-/g, ""); // convert YYYY-MM-DD -> YYYYMMDD
              setValue("BIRTH_DATE", formatted);
            }}
            value={
              watch("BIRTH_DATE")
                ? `${watch("BIRTH_DATE").slice(0, 4)}-${watch(
                    "BIRTH_DATE"
                  ).slice(4, 6)}-${watch("BIRTH_DATE").slice(6, 8)}`
                : ""
            }
          />
        </FormControl>

        <FormControl>
          <FormLabel size="sm" mb={0} color="gray.600" fontWeight="normal">
            SSN
          </FormLabel>
          <InputMask mask="999-99-9999" {...register("SSN")}>
            {(inputProps) => <Input {...inputProps} size="sm" />}
          </InputMask>
        </FormControl>

        <FormControl>
          <FormLabel size="sm" mb={0} color="gray.600" fontWeight="normal">
            JUR. ASSIGNMENT
          </FormLabel>
          <Select
            menuPortalTarget={document.body}
            key={tribeOptions.length}
            menuPosition="fixed"
            styles={selectStyles}
            options={tribeOptions}
            isMulti
            value={tribeOptions.filter((opt) =>
              watch("JURISDICTIONAL_ASSIGNMENT")?.includes(opt.value)
            )}
            onChange={(selected) =>
              setValue(
                "JURISDICTIONAL_ASSIGNMENT",
                selected ? selected.map((opt) => opt.value) : []
              )
            }
          />
        </FormControl>
      </SimpleGrid>
    </Box>
  );
};

export default BasicInformationFormSection;
